export default "__VITE_ASSET__CCNWkAIc__"